import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditIncomePage = {
  alert: {
    error: 'coapplicant-edit-income.form.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-income.footer.root',
  },
  form: {
    amountInput: 'coapplicant-edit-income.form.amount-input',
    amountInputError: 'coapplicant-edit-income.form.amount-input-error',
    cancelButton: 'coapplicant-edit-income.form.cancel-button',
    employerNameInput: 'coapplicant-edit-income.form.employer-name-input',
    employerNameInputError:
      'coapplicant-edit-income.form.employer-name-input-error',
    frequencySelect: 'coapplicant-edit-income.form.frequency-select',
    frequencySelectError: 'coapplicant-edit-income.form.frequency-select-error',
    h1: 'coapplicant-edit-income.form.h1',
    h2: 'coapplicant-edit-income.form.h2',
    hasAdditionalIncomeSelect:
      'coapplicant-edit-income.form.has-additional-income-select',
    hasAdditionalIncomeSelectError:
      'coapplicant-edit-income.form.has-additional-income-select-error',
    incomeTypeSelect: 'coapplicant-edit-income.form.income-type-select',
    incomeTypeSelectError:
      'coapplicant-edit-income.form.income-type-select-error',
    jobTitleInput: 'coapplicant-edit-income.form.job-title-input',
    jobTitleInputError: 'coapplicant-edit-income.form.job-title-input-error',
    monthSelect: 'coapplicant-edit-income.form.month-select',
    monthSelectError: 'coapplicant-edit-income.form.month-select-error',
    root: 'coapplicant-edit-income.form.root',
    submitButton: 'coapplicant-edit-income.form.submit-button',
    yearSelect: 'coapplicant-edit-income.form.year-select',
    yearSelectError: 'coapplicant-edit-income.form.year-select-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-income.header.drawer-button',
    previousStepButton: 'coapplicant-edit-income.header.previous-step-button',
    root: 'coapplicant-edit-income.header.root',
  },
  progress: {
    root: 'coapplicant-edit-income.progress.root',
  },
} as const satisfies PageLocatorMap;
